export interface AnalyticEvent {
  type?: AnalyticEventType;
  action: string;
  category: string;
  label: string;
  value?: number;
}

export interface AnalyticEventDibam {
  delimiter: AnalyticEventDibamDelimiter;
  type: AnalyticEventDibamType;
}

export type AnalyticEventType =
  | 'HOME'
  | 'VISIT'
  | 'SIGNUP_OPEN'
  | 'SIGNUP_OK'
  | 'CHECKOUT_START'
  | 'CHECKOUT_END'
  | 'HOLD_START'
  | 'HOLD_END'
  | 'Inicio de la solicitud'
  | 'Fin de la solicitud';

export enum AnalyticEventDibamDelimiter {
  START = 'Inicio_solicitud',
  END = 'Fin_solicitud',
}

export enum AnalyticEventDibamType {
  SIGNUP = '0400120049',
  CHECKOUT = '0400120050',
  HOLD = '0400120051',
}

export function buildDibamEventPayload(delimiter: AnalyticEventDibamDelimiter, type: AnalyticEventDibamType) {
  return `${delimiter}_${type}`;
}
